import { getItem } from '../storage';

const checkIfClientExists = (clientData, availableClients): boolean => {
    if (clientData && clientData.clientId) {
        const cId = clientData.clientId;
        return !!(availableClients.map(c => c.client).find(o => o.id === cId));
    }
    return false;
};

const getSelectedHotel = (brandSelectionFromReduxStorage, profile, userData) => {
    const searchParams = new URLSearchParams(window.location.search);
    const searchParamsHotelId = searchParams.get('hotelid');

    const brandSelectionFromLocalStorage = getItem('brandHotelSelection');

    const availableClientsTemp = profile && profile.clientList ? profile.clientList : [];
    const availableClients = availableClientsTemp.filter(aC => !!aC.client);

    const isClientAvailableLocalStorage = checkIfClientExists(brandSelectionFromLocalStorage, availableClients);
    const isClientAvailableReduxStorage = checkIfClientExists(brandSelectionFromReduxStorage, availableClients);

    const fromLocalStorage = isClientAvailableLocalStorage
        ? brandSelectionFromLocalStorage
        : { ...brandSelectionFromLocalStorage, clientId: undefined };

    const fromReduxStore = isClientAvailableReduxStorage
        ? brandSelectionFromReduxStorage
        : { ...brandSelectionFromReduxStorage, clientId: undefined };

    const hotelBrandSelection = {
        ...fromLocalStorage,
        ...fromReduxStore,
    };

    const { hotelId } = hotelBrandSelection;
    const selectedHotelId = searchParamsHotelId ? parseInt(searchParamsHotelId) : hotelId;

    let selectedHotel;
    if (userData && userData.brands) {
        for (const brand of userData.brands) {
            for (const hotel of brand.hotels) {
                if (hotel.id === selectedHotelId) {
                    selectedHotel = hotel;
                    break;
                }
            }
        }
    }

    return selectedHotel;
};

export default getSelectedHotel;
